import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const { accTkn } = useSelector((s) => s.LoginReducer);
  const location = useLocation();
  console.log(accTkn)
  if (accTkn) {
    return children;
  }

  return <Navigate to="/login" state={location.pathname} replace />;
}
